
import { Component, Vue, Prop } from 'vue-property-decorator';

import Close from '@/assets/icons/Close.svg';

import ButtonCircle from '@/components/shared/ButtonCircle.vue';

@Component({
  name: 'Modal',
  components: { ButtonCircle, Close },
})
export default class Modal extends Vue {
  @Prop({}) public isClosable!: boolean;
  @Prop({ default: false }) public dark!: boolean;
  @Prop({ default: false }) public overlayDark!: boolean;

  mounted() {
    this.subscribeToEvents();
  }

  public handleClose() {
    this.$emit('close');
  }

  handleEscKeyup(event: KeyboardEvent) {
    const isEscapeKey = event.keyCode === 27;

    if (isEscapeKey && this.isClosable) {
      this.handleClose();
    }
  }

  subscribeToEvents() {
    document.addEventListener('keyup', this.handleEscKeyup);
  }

  unsubscribeToEvents() {
    document.removeEventListener('keyup', this.handleEscKeyup);
  }

  beforeDestroy() {
    this.unsubscribeToEvents();
  }
}
